import { DatePivotParams } from "../../entities/date_pivot_params";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "day",
  segments: [],
  filters: [["status", "in", ["Needs Review"]]],
};
